var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.products.length)?[_c('div',{staticClass:"category-favorite"},[_c('product-carousel',{attrs:{"classes":_vm.classes,"items":_vm.products}})],1)]:[_c('div',[_vm._v("Ваш лист ожидания пуст")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }